import { supabase } from '../lib/supabase';
 
export function useSupabase() {
  return supabase;
} 